import LayoutCustomerSuccess from 'src/components/LayoutCustomerSuccess/LayoutCustomerSuccess';
import Component from 'src/components/OrphanAssigment';

const OrphanAssigment = () => {
    return (
        <LayoutCustomerSuccess title="BROKER CONFIGURATION">
            <Component />
        </LayoutCustomerSuccess>
    );
};

export default OrphanAssigment;
